import { DAVINCI_CDN } from '@/app/_constants/defaultValues';
import { MapPinIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';

type BlurredMapCTAProps = {
  showMap: () => void;
};

const BlurredMapCTA: React.FC<BlurredMapCTAProps> = ({ showMap }) => {
  return (
    <div className="px-4 py-4 lg:hidden xl:px-20">
      <button
        type="button"
        className="group relative flex h-[140px] w-full cursor-pointer items-center justify-center overflow-hidden rounded-lg xl:mx-auto xl:max-w-screen-xl"
        onClick={showMap}
      >
        <Image
          src={`${DAVINCI_CDN}/elty/static-map-background.png`}
          alt="Mappa"
          fill
          objectFit="cover"
          className="absolute left-0 top-0 -z-10 blur-[2px]"
        />

        <div className="flex items-center justify-center gap-2 rounded-full border border-primary bg-white px-4 py-2 text-sm font-semibold text-primary transition-colors group-hover:border-primary-hover group-hover:text-primary-hover">
          <MapPinIcon className="size-5 shrink-0" />
          <span>Vedi su mappa</span>
        </div>
      </button>
    </div>
  );
};

export default BlurredMapCTA;
